/**
 * MobileLayout.js
 * 모바일 전용 레이아웃 컴포넌트
 * Mobile First 전략 - 390px 기준, 수직 스택 레이아웃
 */

import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTheme as useCustomTheme } from '../contexts/ThemeContext';
import MobileBottomNav from '../components/MobileBottomNav';
import TopBar from './TopBar';

const TOP_BAR_HEIGHT = 72; // 모바일에서 더 여유있는 높이

const MobileLayout = () => {
  const { colors } = useCustomTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        maxHeight: '100vh',
        backgroundColor: colors.primaryBg,
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
        overflowY: 'hidden', // 외부 스크롤 방지, 내부 컨텐츠 영역에서만 스크롤
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      {/* 상단 바 (햄버거 메뉴 없음) */}
      <TopBar 
        hideMobileMenu={true}
      />

      {/* 메인 컨텐츠 영역 (하단 네비게이션 공간 확보) */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          paddingTop: `${TOP_BAR_HEIGHT + 16}px`, // TopBar 높이 + 충분한 여백 (16px)
          paddingBottom: '73px', // 하단 네비게이션 공간 (55px + 18px 여백)
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch', // iOS 부드러운 스크롤
          touchAction: 'pan-y', // 수직 스크롤만 허용
          position: 'relative',
          minHeight: 0, // flex 컨테이너에서 스크롤을 위해 필요
          height: `calc(100vh - ${TOP_BAR_HEIGHT}px - 73px)`, // 전체 높이에서 TopBar와 하단 네비게이션 제외
          maxHeight: `calc(100vh - ${TOP_BAR_HEIGHT}px - 73px)`, // 전체 높이에서 TopBar와 하단 네비게이션 제외
        }}
      >
        {/* React Router Outlet - 페이지 컨텐츠가 여기에 렌더링됨 */}
        <Outlet />
      </Box>

      {/* 하단 고정 네비게이션 */}
      <MobileBottomNav />
    </Box>
  );
};

export default MobileLayout;

